import * as React from "react";
import Modal from "../../../ui/modal/Modal";
import ButtonTertiary from "../../../../hiberUiKit/src/atoms/Buttons/ButtonTertiary";
import ButtonPrimary from "../../../../hiberUiKit/src/atoms/Buttons/ButtonPrimary";

interface ComponentProps {
	/**
	 * On close action.
	 */
	onClose: () => void;
	/**
	 * On confirm action.
	 */
	onConfirm: () => void;
	/**
	 * Names of template to be deleted.
	 */
	templateName: string;
}

type Props = ComponentProps;

export default class ConfirmDeleteTemplateModal extends React.PureComponent<Props, {}> {
	render() {
		return (
			<Modal onCloseClicked={this.props.onClose} title={"Confirm"} autoWidth={true}>
				<div style={{width: "500px"}}>
					<p>{`Are you sure you want to delete template ${this.props.templateName}?`}</p>
					<ButtonTertiary label={"Cancel"} onClick={this.props.onClose}/>
					<div className={"pull-right"}><ButtonPrimary label={"Process"} onClick={this.onProcessClick}/></div>
				</div>
			</Modal>
		)
	}

	onProcessClick = () => {
		this.props.onConfirm();
		this.props.onClose();
	}
}
